export default function Footer(){
    return(
        <div className="footer">
            <span>Fitness Tracker™</span>
        </div>
    )}